var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CFBaseButtonUtils, } from '@connectrn/ds-ui-base';
import { CFIcon } from '../../components';
import { commonAttrs } from '../../utils';
import { CFButtonStyledElements } from './Button.styles';
export const CFButton = (_a) => {
    var { accessibleLabel, alignment = 'center', children, disabled = false, iconLeft, iconRight, rounded, shadow, size = 'md', variant = 'primary', widthPreset, 
    // Web-specific
    href, onClick } = _a, rest = __rest(_a, ["accessibleLabel", "alignment", "children", "disabled", "iconLeft", "iconRight", "rounded", "shadow", "size", "variant", "widthPreset", "href", "onClick"]);
    const { Label, Root, Wrapper } = CFButtonStyledElements;
    const { getIconColor, getIconSize } = CFBaseButtonUtils;
    const iconOnly = !children && iconLeft && !iconRight;
    const smallText = !iconLeft &&
        !iconRight &&
        children &&
        typeof children === 'string' &&
        children.length <= 2;
    const renderIcon = (iconConfigs, buttonSize) => {
        if (!iconConfigs)
            return null;
        const color = getIconColor({ disabled, variant }, iconOnly);
        const size = getIconSize(buttonSize);
        if (typeof iconConfigs === 'string') {
            return React.createElement(CFIcon, { color: color, icon: iconConfigs, size: size });
        }
        const { color: iconColor, icon, variant: iconVariant } = iconConfigs;
        return (React.createElement(CFIcon, { color: iconColor !== null && iconColor !== void 0 ? iconColor : color, icon: icon, size: size, variant: iconVariant }));
    };
    return (React.createElement(Wrapper, Object.assign({ disabled: disabled, "$iconOnly": iconOnly || smallText, "$size": size, "$variant": variant, "$widthPreset": widthPreset, "aria-label": accessibleLabel, "aria-disabled": disabled, as: href ? 'a' : 'button', href: href, onClick: onClick, role: 'button', type: 'button' }, commonAttrs(rest)),
        React.createElement(Root, { "$alignment": alignment, "$disabled": disabled, "$iconOnly": iconOnly || smallText, "$rounded": rounded, "$shadow": shadow, "$size": size, "$variant": variant, "$widthPreset": widthPreset },
            renderIcon(iconLeft, size),
            children && (React.createElement(Label, { "$alignment": alignment, "$disabled": disabled, "$size": size, "$variant": variant }, children)),
            renderIcon(iconRight, size))));
};
